<template>
    <div>
        <transition name="loader-fade">
            <div v-if="!pageReady" class="endurance-loader">
                <div class="loader-content">
                    <div class="loader-title" :style="{ color: loaderColors.dot1 }">THE ENDURANCE</div>
                    <div class="loader-dots">
                        <span class="dot dot-1" :style="{ backgroundColor: loaderColors.dot1 }"></span>
                        <span class="dot dot-2" :style="{ backgroundColor: loaderColors.dot2 }"></span>
                        <span class="dot dot-3" :style="{ backgroundColor: loaderColors.dot3 }"></span>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="section-fade">
        <div v-if="pageReady && endurancePage" class="site-black-bg d-flex flex-column mycon">
        <div id="Page">
                <template v-if="endurancePage.show_banner">
                    <img v-if="endurancePage.banner_image" style="width:100%;height:auto"
                        :src="`${$API_ASSETS}${endurancePage.banner_image.id}?width=1400&quality=80`"
                        fetchpriority="high" />
                    <img v-else style="width:100%;height:auto" src="@/assets/endurance/Endurance25-webheader.jpg" />
                </template>

                <div class="Section-Content">
                    <div class="Description">
                        <div v-if="endurancePage.header_1" class="pb-2">
                            <h1 :class="endurancePage.header_1_hex ? '' : 'sponsors'"
                                :style="endurancePage.header_1_hex ? { color: endurancePage.header_1_hex, borderBottom: '5px solid ' + endurancePage.header_1_hex } : {}">
                                {{ endurancePage.header_1 }}</h1>
                        </div>
                        <div v-if="endurancePage.content_1" v-html="decodeHTML(endurancePage.content_1)"
                            class="mb-4 mt-n2 pt-3"></div>

                        <div v-if="endurancePage.header_2" class="pb-2">
                            <h2 :class="endurancePage.header_2_hex ? '' : 'visitors'"
                                :style="endurancePage.header_2_hex ? { color: endurancePage.header_2_hex, borderBottom: '5px solid ' + endurancePage.header_2_hex } : {}">
                                {{ endurancePage.header_2 }}</h2>
                        </div>

                        <div v-if="endurancePage.content_2" v-html="decodeHTML(endurancePage.content_2)"
                            class="mb-4 mt-n2 pt-3"></div>

                        <div v-if="endurancePage.show_schedule" class="mb-4" id="schedule-top">
                            <h2 :class="endurancePage.schedule_header_hex ? '' : 'workshops'"
                                :style="endurancePage.schedule_header_hex ? { color: endurancePage.schedule_header_hex, borderBottom: '5px solid ' + endurancePage.schedule_header_hex } : {}">
                                Schedule</h2>
                            <div v-if="Object.keys(groupedTimeblocks).length > 1" class="d-flex justify-content-center flex-wrap mt-2 mb-2" style="gap: 15px;">
                                <a v-for="(dayName, index) in Object.keys(groupedTimeblocks)" :key="dayName"
                                   :href="`#schedule-day-${index}`" 
                                   style="font-weight: bold; text-decoration: underline;" 
                                   :style="{ color: endurancePage.header_1_hex || '#333' }">
                                    {{ dayName.split(',')[0] }}
                                </a>
                            </div>
                            <img v-if="endurancePage.schedule_image" style="width:100%;height:auto" class="mt-2"
                                :src="`${$API_ASSETS}${endurancePage.schedule_image.id}.png`" />
                            <div class="table-wrapper mt-4 mx-auto" v-if="Object.keys(groupedTimeblocks).length > 0" style="text-align: left; max-width: 600px;">
                                <div v-for="(blocks, date, index) in groupedTimeblocks" :key="date" class="mb-4" :id="'schedule-day-' + index">
                                    <div class="day-header-wrapper" :style="endurancePage.schedule_header_hex ? { borderBottom: '2px solid ' + endurancePage.schedule_header_hex } : { borderBottom: '2px solid #333' }">
                                        <h3 class="subheader pb-2 font-weight-bold mb-0" :class="endurancePage.schedule_header_hex ? '' : 'schedule'" :style="endurancePage.schedule_header_hex ? { color: endurancePage.schedule_header_hex } : {}" style="width: 100%; padding-top: 0;">{{ date }}</h3>
                                        <a href="#schedule-top" class="day-back-to-top desktop-only" :style="{ color: endurancePage.header_1_hex || '#333' }">Top</a>
                                    </div>
                                    <a href="#schedule-top" class="day-back-to-top mobile-only" :style="{ color: endurancePage.header_1_hex || '#333' }">Top</a>
                                    <ul class="mt-3">
                                        <li v-for="block in blocks" :key="block.id" style="display: flex; margin-bottom: 40px;">
                                            <div style="min-width: 100px; padding-top: 2px;">
                                                <span class="event-time font-weight-bold" style="display: block;">{{ formatTime(block.start_time) }}</span>
                                                <a v-if="block.is_workshop && block.cw_link" :href="block.cw_link" target="_blank" style="font-size: 13px; font-weight: bold; display: block; margin-top: 5px;">Register</a>
                                                <a v-else-if="!block.is_workshop && block.block_number" :href="`https://www.crowdwork.com/e/endurance-block-${block.block_number}`" target="_blank" style="font-size: 13px; font-weight: bold; display: block; margin-top: 5px;">Tickets</a>
                                            </div>
                                            <div class="event-details" style="flex: 1;">
                                                <div v-if="block.team1_id">
                                                    <div style="display: flex; flex-wrap: wrap; align-items: baseline; column-gap: 5px; margin-bottom: 12px; line-height: 1.1;">
                                                        <strong :style="isPast(block.start_time) ? { textDecoration: 'line-through', opacity: '0.55' } : {}">{{ stripTags(block.team1_id.display_name) }}</strong>
                                                        <span v-if="block.team1_id.city && block.team1_id.state" style="font-size: 14px; font-weight: normal;" class="text-muted">({{ block.team1_id.city }}, {{ block.team1_id.state }})</span>
                                                    </div>
                                                    <div v-if="block.team1_id.team_members || block.team1_id.description" class="mt-1 mb-2" style="font-size: 14px;">
                                                        <div v-if="block.team1_id.team_members" class="mb-1">
                                                            <div style="font-weight: bold; display: flex; flex-wrap: wrap; column-gap: 8px; row-gap: 2px;">
                                                                <span v-for="(member, index) in getCastList(block.team1_id.team_members)" :key="index" style="white-space: nowrap;">
                                                                    <span :style="{ color: getCastColor(index) }">{{ member }}</span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div v-if="block.team1_id.description" class="mb-2" style="font-style: italic;">
                                                            {{ stripTags(block.team1_id.description) }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="block.team2_id" :class="block.team1_id ? 'mt-4' : ''">
                                                    <div style="display: flex; flex-wrap: wrap; align-items: baseline; column-gap: 5px; margin-bottom: 12px; line-height: 1.1;">
                                                        <strong :style="isPast(block.start_time) ? { textDecoration: 'line-through', opacity: '0.55' } : {}">{{ stripTags(block.team2_id.display_name) }}</strong>
                                                        <span v-if="block.team2_id.city && block.team2_id.state" style="font-size: 14px; font-weight: normal;" class="text-muted">({{ block.team2_id.city }}, {{ block.team2_id.state }})</span>
                                                    </div>
                                                    <div v-if="block.team2_id.team_members || block.team2_id.description" class="mt-1 mb-2" style="font-size: 14px;">
                                                        <div v-if="block.team2_id.team_members" class="mb-1">
                                                            <div style="font-weight: bold; display: flex; flex-wrap: wrap; column-gap: 8px; row-gap: 2px;">
                                                                <span v-for="(member, index) in getCastList(block.team2_id.team_members)" :key="index" style="white-space: nowrap;">
                                                                    <span :style="{ color: getCastColor(index) }">{{ member }}</span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div v-if="block.team2_id.description" class="mb-2" style="font-style: italic;">
                                                            {{ stripTags(block.team2_id.description) }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="!block.team1_id && !block.team2_id">
                                                    <em>TBA</em>
                                                </div>
                                                <div v-if="block.cw_link && !block.is_workshop" class="mt-1">
                                                    <a :href="block.cw_link" target="_blank" style="font-size: 13px; font-weight: bold;">Get Tickets</a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="endurancePage.header_3" class="pb-2">
                            <h2 :class="endurancePage.header_3_hex ? '' : 'schedule'"
                                :style="endurancePage.header_3_hex ? { color: endurancePage.header_3_hex, borderBottom: '5px solid ' + endurancePage.header_3_hex } : {}">
                                {{ endurancePage.header_3 }}</h2>
                        </div>
                        <div v-if="endurancePage.content_3" v-html="decodeHTML(endurancePage.content_3)"
                            class="mb-4 mt-n2 pt-3"></div>
                    </div>



                </div>

                <!-- <div class="Section-Content">
                    <div class="Description">
                        <h3 class="blue"> SHOWS TAKE PLACE AT <a
                                href="https://www.google.com/maps/place/Atlas+Improv+Company/@43.0785774,-89.3802784,17z/data=!4m3!3m2!1s0x8806533730bda43b:0x14e9673c901ec5bb!4b1">609
                                E WASHINGTON AVE, MADISON, WI</a></h3>
                    </div>
                </div> -->
            </div>
            <Footer />
        </div>
        </transition>
    </div>

</template>

<script>
import axios from "axios";
import Footer from "@/components/Footer.vue";
import { useHead } from '@vueuse/head';
import { useRoute } from 'vue-router';

export default {
    setup() {
        const route = useRoute();
        useHead({
            title: route.meta.title || 'Atlas Improv',
            meta: [
                { name: 'description', content: route.meta.description || '' }
            ]
        });
        return {};
    },
    components: {
        Footer
    },
    data() {
        return {
            endurancePage: null,
            timeblocks: [],
            expandedTeams: [],
            pageReady: false,
            error: null,
            loaderColors: { dot1: '#1DB1D9', dot2: '#ec4956', dot3: '#98ca3c' }
        }
    },
    computed: {
        groupedTimeblocks() {
            const groups = {};
            this.timeblocks.forEach(block => {
                const dateKey = this.formatDate(block.start_time);
                if (!groups[dateKey]) {
                    groups[dateKey] = [];
                }
                groups[dateKey].push(block);
            });
            return groups;
        }
    },
    methods: {
        formatTime(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        },
        formatDate(dateString) {
           if (!dateString) return '';
           const date = new Date(dateString);
           return date.toLocaleDateString([], { weekday: 'long', month: 'long', day: 'numeric' });
        },
        toggleTeam(teamId) {
            const index = this.expandedTeams.indexOf(teamId);
            if (index > -1) {
                this.expandedTeams.splice(index, 1);
            } else {
                this.expandedTeams.push(teamId);
            }
        },
        isExpanded(teamId) {
            return this.expandedTeams.includes(teamId);
        },
        stripTags(html) {
            if (!html) return '';
            let tmp = document.createElement("DIV");
            // First decode HTML entities (like &nbsp;)
            tmp.innerHTML = html;
            let decoded = tmp.textContent || tmp.innerText || "";
            // Then strip any remaining tags
            tmp.innerHTML = decoded;
            return (tmp.textContent || tmp.innerText || "").trim();
        },
        getCastList(html) {
            if (!html) return [];
            const cleanText = this.stripTags(html);
            return cleanText.split(',').map(m => m.trim()).filter(m => m !== '');
        },
        getCastColor(index) {
            if (!this.endurancePage) return '#333';
            
            // Create a 3-color palette to prevent vertical striping when 2 or 4 items wrap per line
            const palette = [
                this.endurancePage.header_1_hex,
                this.endurancePage.schedule_header_hex,
                this.endurancePage.header_2_hex
            ];
            
            // Fallback colors just in case the CMS is missing a hex value
            if (!palette[0]) palette[0] = '#e91e63'; // pink
            if (!palette[1]) palette[1] = '#ff9800'; // orange
            if (!palette[2]) palette[2] = '#9c27b0'; // purple
            
            return palette[index % 3];
        },
        isPast(dateString) {
            if (!dateString) return false;
            return new Date(dateString) < new Date();
        },
        decodeHTML(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },
        async fetchEnduranceData() {
            this.loading = true;
            this.error = null;
            const url = this.$API_GRAPHQL;
            const minDelay = new Promise(resolve => setTimeout(resolve, 2000));
            try {
                const response = await axios.post(url, {
                    query: `
        query {
          endurance_page {
           show_banner
           show_schedule
           header_1
           header_1_hex
           header_2_hex
           header_3_hex
           schedule_header_hex
           header_2
           header_3
           content_1
           content_2
           content_3
           banner_image{
            id
           }
           schedule_image{
            id
           }
        }
        endurance_timeblocks(sort: ["block_number"]) {
            id
            start_time
            end_time
            block_number
            team1_id {
                id
                display_name
                city
                state
                description
                team_members
                is_atlas
            }
            team2_id {
                id
                display_name
                city
                state
                description
                team_members
                is_atlas
            }
            cw_link
        }
        endurance_workshop {
            id
            start_time
            end_time
            name
            instructor
            description
            cw_link
        }
        }
                    `
                }, {
                    headers: {
                        'Authorization': `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
                        'Content-Type': 'application/json'
                    }
                });
                const payload = response?.data?.data?.endurance_page;
                this.endurancePage = Array.isArray(payload) ? payload[0] : payload || null;
                const timeblocks = response?.data?.data?.endurance_timeblocks || [];
                const workshopData = response?.data?.data?.endurance_workshop;
                const workshops = workshopData ? [workshopData] : [];

                const mappedWorkshops = workshops.map(w => ({
                    id: `workshop-${w.id}`,
                    start_time: w.start_time,
                    end_time: w.end_time,
                    is_workshop: true,
                    team1_id: {
                        id: `w-${w.id}`,
                        display_name: w.name,
                        team_members: w.instructor,
                        description: w.description
                    },
                    cw_link: w.cw_link
                }));

                this.timeblocks = [...timeblocks, ...mappedWorkshops].sort((a, b) => new Date(a.start_time) - new Date(b.start_time));

                const imageUrls = [];
                if (this.endurancePage?.show_banner && this.endurancePage?.banner_image) {
                    imageUrls.push(`${this.$API_ASSETS}${this.endurancePage.banner_image.id}?width=1400&quality=80`);
                }
                if (this.endurancePage?.schedule_image) {
                    imageUrls.push(`${this.$API_ASSETS}${this.endurancePage.schedule_image.id}.png`);
                }
                // update dot colors as soon as we have them, while min timer still runs
                if (this.endurancePage) {
                    this.loaderColors = {
                        dot1: this.endurancePage.header_1_hex || '#1DB1D9',
                        dot2: this.endurancePage.header_2_hex || '#ec4956',
                        dot3: this.endurancePage.schedule_header_hex || '#98ca3c'
                    };
                }
                await Promise.all([
                    minDelay,
                    ...imageUrls.map(src => new Promise(resolve => {
                        const img = new Image();
                        img.onload = img.onerror = resolve;
                        img.src = src;
                    }))
                ]);
            } catch (error) {
                console.error('Error fetching endurance page data:', error);
                this.error = error;
                await minDelay;
            } finally {
                this.pageReady = true;
            }
        }
    },
    created() {
        this.fetchEnduranceData();
    }
}
</script>

<style>
.section-fade-enter-active {
    transition: opacity 0.6s ease;
}
.section-fade-enter-from {
    opacity: 0;
}

.loader-fade-leave-active {
    transition: opacity 0.5s ease;
}
.loader-fade-leave-to {
    opacity: 0;
}

.endurance-loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #1f272f url('@/assets/endurance/end_back_final.png') repeat center top;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1040;
}

.loader-content {
    text-align: center;
}

.loader-title {
    font-family: "Bluescreens Bold", HelveticaNeue, "Helvetica Neue", sans-serif;
    font-size: 6em;
    color: #1DB1D9;
    letter-spacing: 3px;
    animation: endurance-pulse 1.8s ease-in-out infinite;
    transition: color 1.4s ease;
}

.loader-dots {
    display: flex;
    justify-content: center;
    gap: 14px;
    margin-top: 24px;
}

.loader-dots .dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    animation: endurance-bounce 1.3s ease-in-out infinite;
    transition: background-color 1.4s ease;
}

.loader-dots .dot-1 { animation-delay: 0s; }
.loader-dots .dot-2 { animation-delay: 0.22s; }
.loader-dots .dot-3 { animation-delay: 0.44s; }

@keyframes endurance-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
}

@keyframes endurance-bounce {
    0%, 100% { transform: translateY(0); opacity: 1; }
    50% { transform: translateY(-14px); opacity: 0.5; }
}

@media screen and (max-width: 663px) {
    .loader-title {
        font-size: 3em;
    }
}
</style>

<style scoped>

/* @group Font */

/* Bluescreens Bold */
@font-face {
    font-family: 'Bluescreens Bold';
    src: url('@/assets/fonts/Bluescreens/tt-bluescreens-bold-webfont.eot?');
    src: url('@/assets/fonts/Bluescreens/tt-bluescreens-bold-webfont.eot?#iefix') format('embedded-opentype'),
        url('@/assets/fonts/Bluescreens/tt-bluescreens-bold-webfont.woff') format('woff'),
        url('@/assets/fonts/Bluescreens/tt-bluescreens-bold-webfont.ttf') format('truetype'),
        url('@/assets/fonts/Bluescreens/tt-bluescreens-bold-webfont.svg#tt-bluescreens-bold-webfont') format('svg');
    font-weight: bold;
    font-style: normal;
}

/* Uniform Ultra */
@font-face {
    font-family: 'Uniform Ultra';
    src: url('@/assets/fonts/Ultra/uniform-ultra-webfont.eot?');
    src: url('@/assets/fonts/Ultra/uniform-ultra-webfont.eot?#iefix') format('embedded-opentype'),
        url('@/assets/fonts/Ultra/uniform-ultra-webfont.woff') format('woff'),
        url('@/assets/fonts/Ultra/uniform-ultra-webfont.ttf') format('truetype'),
        url('@/assets/fonts/Ultra/uniform-ultra-webfont.svg#uniform-ultra-webfont') format('svg');
    font-weight: normal;
    font-style: normal;
}

/* @end */

.mycon {
    /* Merging body styles from main.css */
    background: #1f272f url(@/assets/endurance/end_back_final.png) repeat center top;
    margin: 0;
    padding: 0;
    text-align: left;
    font: 16px "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif;
    line-height: 1.50;
    color: #292928;
    width: 100%;
    min-height: 60vh;
}

#Page {
    max-width: 1200px;
    margin: 0px auto 0px auto;
    min-height: 60vh;
}

/* Nav styles removed as we use Vue component */

.Section {
    margin-bottom: 25px;
}

.visitors .column-left,
.visitors .column-right {
    font: 41px "Bluescreens Bold", HelveticaNeue, "Helvetica Neue", sans-serif;
    letter-spacing: 1px;
    text-transform: uppercase;
}

.Atlas-Team,
.Atlas-Team img {
    display: inline;
    vertical-align: 3px;
}

.Visitor-Info {
    display: inline;
    font: 13px "Uniform Ultra", HelveticaNeue, "Helvetica Neue", sans-serif;
    letter-spacing: 0;
}

.workshops .column-left,
.workshops .column-right {
    font-size: 14px;
}

.Section-Header {
    text-align: center;
    display: block;
}

img.Next {
    max-width: 870px;
    width: 100%;
    text-align: center;
    display: block;
    margin: 0 auto 0 auto;
}

.Endurance-Logo {
    font: 15.6em/1em "Bluescreens Bold", HelveticaNeue, "Helvetica Neue", sans-serif;
    margin: 0;
    padding: 0;
    z-index: 1;
}

.Improv-Fest-Sub {
    font: 3em "Uniform Ultra", HelveticaNeue, "Helvetica Neue", sans-serif;
    color: #ffffff;
    background-color: #292928;
    text-align: center;
    padding-right: 25px;
    padding-left: 25px;
    margin: 0;
}

.Section-Content {
    padding-right: 0;
    padding-left: 0;
    margin-top: 0;
    margin-bottom: 20px;
}

/* Footer styles removed as we use Vue component */

h1,
h2,
h3 {
    font-family: "Uniform Ultra", HelveticaNeue, "Helvetica Neue", sans-serif;
    text-transform: uppercase;
    display: inline;
    margin: 0;
    padding: 0;
}

h1 {
    font-size: 55px;
}

h2 {
    font-size: 35px;
}

.blue {
    font-family: "Bluescreens Bold", HelveticaNeue, "Helvetica Neue", sans-serif;
}

h3 {
    font-family: "Uniform Ultra", HelveticaNeue, "Helvetica Neue", sans-serif;
    font-size: 25px;
    line-height: 1.0;
}

.lihead {
    font-family: "Uniform Ultra", HelveticaNeue, "Helvetica Neue", sans-serif;
}

h3.time {
    font-family: "Bluescreens Bold", HelveticaNeue, "Helvetica Neue", sans-serif;
}

h1.visitors {
    color: #1DB1D9;
    border-bottom: 5px solid #1DB1D9;
}

h1.workshops {
    color: #ec4956;
    border-bottom: 5px solid #ec4956;
}

h1.schedule {
    color: #98ca3c;
    border-bottom: 5px solid #98ca3c;
}

h1.sponsors {
    color: #ec4956;
    border-bottom: 5px solid #ec4956;
}

h1.location {
    color: #1DB1D9;
    border-bottom: 5px solid #1DB1D9;
}

a {
    color: #459fcc;
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

.column-left {
    float: left;
    width: 49%;
}

.column-right {
    float: right;
    width: 49%;
}

.workshops img {
    width: 100%;
}

.clear {
    clear: both;
}

img {
    border-style: none;
    border-width: 0;
}

.Description {
    font-size: 18px;
    max-width: 550px;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
    padding-top: 20px;
}

.nopad {
    font-size: 18px;
    max-width: 550px;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
}

.byline {
    font-size: 14px;
    max-width: 550px;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
}


.sponsors {
    max-width: 550px;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
}

.sponsors img {
    margin: 20px 15px;
}

a.press {
    color: #444444;
    text-decoration: none;
    font-size: 12px;
}


/* @group Optimized */

@media screen and (max-width: 1024px) {
    .Section {
        padding-right: 15px;
        padding-left: 15px;
    }

    .Endurance-Logo {
        font-size: 11em;
    }
}

@media screen and (max-width: 663px) {

    /* body style moved to .mycon */
    .mycon {
        font-family: "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif;
        line-height: 1.50;
    }

    .Endurance-Logo {
        font-size: 4em;
    }

    .Improv-Fest-Sub {
        font-size: 2em;
    }

    .Description {
        padding-right: 30px;
        padding-left: 30px;
        font-size: 1.1em;
    }

    h1 {
        font-size: 2.1em;
    }

    h2 {
        font-size: 1.9em;
    }

    h3 {
        font-size: 1.5em;
    }

    .visitors .column-left,
    .visitors .column-right {
        font-size: 2em;
    }

    .Visitor-Info {
        font-size: 0.3em;
        display: block;
        margin: 0 0 -33px;
        padding: 0;
    }

    .responsive {
        width: 100%;
        height: auto;
        display: block;
        line-height: .5;
    }


    .column-left,
    .column-right {
        float: none;
        width: 100%;
        padding-top: 15px;
    }

    .sponsors img {
        width: 25%;
    }

}

@media handheld,
only screen and (max-device-width: 480px) {}

/* @end */

/* Additional styles from index.html */
.table-wrapper {
    width: 100%;
    /* Or specify another width */
    text-align: center;
    /* This centers the table in modern browsers */
}

strong {
    padding-bottom: 8px;
}

ul {
    list-style: none;
    padding-left: 0;
}

li {
    margin-bottom: 10px;
}

strong {
    font-size: 20px;
}

.subheader {
    font-weight: bold;
}

table {
    margin-left: auto;
    margin-right: auto;
    border-collapse: collapse;
    border: none;
}

ul li .event-time {
    display: inline-block;
    width: 100px;
    /* Adjust if necessary */
    text-align: left;
    /* Ensures text within the block aligns left */
    margin-right: 10px;
    /* Adds spacing between the time and the event description */
}

.mt-n2 {
    margin-top: -0.5rem !important;
}
</style>
